import { resolveHomepageSectionsImage } from '../../../../../helpers/construct/page-content.helper';
import { convertToSplashAlignment, convertToSplashButtonStyle } from '../../../../../helpers/home/splash/splash.helper';
import { type ContentComponent, type HomePageSplashContent } from '../../../../../types/construct.types';
import { HomeSplash } from '../../../../home-components/home-splash/home-splash.component';

export const HomeSplashHandler: ContentComponent<HomePageSplashContent> = ({
	content: {
		fields: { background, desktop, alignment, mobile, link, backgroundTracking, buttonTracking, buttonText, buttonStyle }
	}
}) => {
	return (
		<HomeSplash
			background={resolveHomepageSectionsImage(background)}
			backgroundTracking={backgroundTracking}
			callToAction={{
				desktop: resolveHomepageSectionsImage(desktop),
				mobile: resolveHomepageSectionsImage(mobile),
				alignment: convertToSplashAlignment(alignment),
				style: convertToSplashButtonStyle(buttonStyle),
				text: buttonText ?? '',
				foregroundTracking: buttonTracking ?? null,
				link: {
					name: 'Link',
					url: link.linkUrl,
					tracking: link.trackingCode ?? ''
				}
			}}
		/>
	);
};
